import React, { FC, useMemo } from 'react'
import { Questions } from '@mortgage-pos/types'
import { QuestionsList } from './QuestionsList'

interface Props {
  title?: string
  subTitle?: string
  groupName: string
  formValues: object
  questions: Questions[]
  modifierClass: string
}

export const QuestionGroup: FC<Props> = ({
  title,
  subTitle,
  groupName,
  formValues,
  questions,
  modifierClass,
}) => {
  const [questionGroupValues] = useMemo<object[]>(
    () => formValues[groupName],
    [formValues, groupName]
  )

  return (
    <div
      key={`question-group-${groupName}`}
      className={`question-group__group-wrapper ${modifierClass || ''}`}
      data-testid={`question-group-${groupName}`}
    >
      <QuestionsList
        title={title}
        subTitle={subTitle}
        questionGroupName={groupName}
        questionGroupValues={questionGroupValues}
        questions={questions}
      />
    </div>
  )
}
